import React, { useEffect, useState } from 'react';
export function ExitIntentPopup() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('showExitPopup', handler);
    return () => window.removeEventListener('showExitPopup', handler);
  }, []);
  if (!visible) return null;
  const handleAccept = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales + El Altar Digital (Bundle Popup)',
        content_type: 'product',
        value: 23490,
        currency: 'ARS'
      });
      fbq('track', 'InitiateCheckout', {
        content_name: 'Kit Digital 33 Rituales + El Altar Digital (Bundle Popup)',
        content_type: 'product',
        value: 23490,
        currency: 'ARS',
        num_items: 1
      });
    }
    window.location.href = 'https://ebookpromax.com/cart/add?id=46614695116958&quantity=1';
  };
  const handleDecline = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 19990,
        currency: 'ARS'
      });
      fbq('track', 'InitiateCheckout', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 19990,
        currency: 'ARS',
        num_items: 1
      });
    }
    window.location.href = 'https://ebookpromax.com/cart/add?id=46586630013086&quantity=1';
  };
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center p-3" role="dialog" aria-modal="true" aria-label="Oferta especial antes de finalizar tu compra" data-id="element-79">
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[rgba(10,8,18,0.85)] backdrop-blur-sm" onClick={handleDecline} data-id="element-80" />

      {/* Popup card */}
      <div className="relative w-full max-w-[480px] rounded-[16px] border-2 border-[var(--gold)] shadow-[0_0_80px_-10px_rgba(232,150,12,0.3),0_32px_64px_-16px_rgba(0,0,0,0.7)]" style={{
      background: 'linear-gradient(160deg, #1A1628 0%, #221E32 40%, #1A1628 100%)',
      animation: 'popupSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
    }} data-id="element-81">
        {/* Top gold accent line */}
        <div className="h-[2px] bg-[linear-gradient(90deg,transparent,var(--gold),var(--gold-l),var(--flame2),var(--gold),transparent)]" data-id="element-82" />

        {/* HEADER */}
        <div className="bg-[linear-gradient(135deg,rgba(232,150,12,0.15),rgba(255,107,53,0.08))] border-b border-[rgba(232,150,12,0.2)] px-4 md:px-6 pt-4 pb-3 text-center" data-id="element-83">
          <span className="inline-flex items-center gap-[5px] py-1 px-2.5 rounded-full border border-[rgba(255,107,53,0.5)] bg-[rgba(255,107,53,0.12)] text-[9px] md:text-[10px] tracking-[0.14em] uppercase text-[var(--flame2)] font-bold mb-2 backdrop-blur-sm" data-id="element-84">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" data-id="element-85">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-86" />
            </svg>
            Oferta exclusiva — Solo en esta pantalla
          </span>
          <h2 className="font-serif text-[clamp(1.3rem,4.5vw,1.8rem)] font-700 text-white leading-[1.2] mb-1" data-id="element-87">
            🔥 ¡Esperá! No te vayas sin esto...
          </h2>
          <p className="text-[clamp(0.85rem,2.2vw,0.95rem)] text-[var(--lila-pale)] italic font-400 leading-[1.4]" data-id="element-88">
            Llevá el paquete completo y asegurá una{' '}
            <strong className="text-[#E8C88A] font-700 not-italic" data-id="element-89">
              experiencia de liberación real
            </strong>
          </p>
        </div>

        {/* BODY */}
        <div className="px-4 md:px-6 pt-4 pb-4" data-id="element-90">
          {/* COMPACT INCLUDED LIST */}
          <div className="bg-[rgba(232,150,12,0.04)] border border-[rgba(232,150,12,0.15)] rounded-lg p-3 mb-4" data-id="element-91">
            <div className="text-[9px] md:text-[10px] uppercase tracking-[0.15em] text-[var(--gold)] font-700 mb-2 text-center" data-id="element-92">
              Tu paquete completo incluye:
            </div>
            <div className="flex flex-col gap-[6px]" data-id="element-93">
              <div className="flex items-center gap-2 text-[clamp(0.8rem,2.2vw,0.9rem)] text-[var(--text)] font-400 leading-[1.4]" data-id="element-94">
                <span className="flex-shrink-0" data-id="element-95">📘</span>
                <span data-id="element-96">
                  <strong className="text-white font-600" data-id="element-97">
                    33 Rituales para Soltar el Pasado
                  </strong>
                </span>
              </div>
              <div className="flex items-center gap-2 text-[clamp(0.8rem,2.2vw,0.9rem)] text-[var(--text)] font-400 leading-[1.4]" data-id="element-98">
                <span className="flex-shrink-0" data-id="element-99">📓</span>
                <span data-id="element-100">
                  <strong className="text-white font-600" data-id="element-101">
                    Bono: Diario Terapéutico
                  </strong>
                </span>
              </div>
              <div className="flex items-center gap-2 text-[clamp(0.8rem,2.2vw,0.9rem)] text-[var(--text)] font-400 leading-[1.4]" data-id="element-102">
                <span className="flex-shrink-0" data-id="element-103">⚡</span>
                <span data-id="element-104">
                  <strong className="text-white font-600" data-id="element-105">
                    Bono: 7 Rituales de Emergencia
                  </strong>
                </span>
              </div>
              <div className="flex items-center gap-2 text-[clamp(0.8rem,2.2vw,0.9rem)] text-[var(--text)] font-400 leading-[1.4] border-t border-[rgba(232,150,12,0.15)] pt-[6px] mt-[2px]" data-id="element-106">
                <span className="flex-shrink-0" data-id="element-107">🕯️</span>
                <span data-id="element-108">
                  <strong className="text-[var(--gold-l)] font-700" data-id="element-109">
                    El Altar Digital
                  </strong>{' '}
                  — Rituales 10x más efectivos
                </span>
              </div>
            </div>
          </div>

          {/* PRICING BLOCK */}
          <div className="text-center mb-4" data-id="element-110">
            <div className="flex items-center justify-center gap-[5px] text-[clamp(0.65rem,1.4vw,0.72rem)] text-[var(--text)] opacity-70 mb-1.5 font-400" data-id="element-111">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--gold)]" data-id="element-112">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-113" />
              </svg>
              Pago seguro · Descarga inmediata · Garantía 7 días
            </div>
            <div className="text-[clamp(0.9rem,2.5vw,1rem)] text-[var(--muted)] line-through decoration-[rgba(232,150,12,0.4)] mb-0.5 font-400" data-id="element-114">
              Precio normal: $28.980 ARS
            </div>
            <div className="font-serif text-[clamp(2.2rem,8vw,3.2rem)] text-[var(--gold-l)] font-900 leading-none mb-0.5" style={{
            textShadow: '0 0 40px rgba(245,192,48,0.3), 0 0 80px rgba(232,150,12,0.15)'
          }} data-id="element-115">
              $23.490 ARS
            </div>
            <p className="text-[clamp(0.65rem,1.4vw,0.72rem)] tracking-[0.1em] uppercase text-[var(--flame2)] font-700" data-id="element-116">
              Precio especial solo disponible en esta pantalla
            </p>
          </div>

          {/* CTA BUTTONS */}
          <div className="flex flex-col items-center gap-2" data-id="element-117">
            <button onClick={handleAccept} className="exit-popup-accept-btn w-full max-w-[420px] inline-flex items-center justify-center gap-2 bg-[linear-gradient(135deg,var(--gold)_0%,var(--gold-l)_50%,var(--gold)_100%)] bg-[length:200%_auto] text-[#1A1025] font-bold text-[clamp(0.82rem,2.5vw,0.95rem)] tracking-[0.05em] uppercase py-[14px] px-5 rounded-full border-none cursor-pointer transition-all duration-300 leading-[1.2] text-center" style={{
            animation: 'exitPopupPulse 2.5s ease-in-out infinite',
            fontFamily: "'Lato', sans-serif"
          }} data-id="element-118">
              🔥 SÍ, QUIERO EL PAQUETE COMPLETO POR $23.490
            </button>
            <button onClick={handleDecline} className="bg-transparent border-none cursor-pointer text-[clamp(0.78rem,1.8vw,0.88rem)] text-[var(--muted)] hover:text-[var(--text)] transition-colors duration-200 py-1.5 px-3 font-400 italic" style={{
            fontFamily: "'Lato', sans-serif"
          }} data-id="element-119">
              No gracias, continuar sin los extras →
            </button>
          </div>
        </div>

        {/* Close button */}
        <button onClick={handleDecline} className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-[var(--muted)] hover:text-white hover:bg-[rgba(255,255,255,0.1)] transition-all duration-200 cursor-pointer" aria-label="Cerrar" data-id="element-120">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-121">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-122" />
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-123" />
          </svg>
        </button>
      </div>
    </div>;
}